import { Check, Copy } from 'lucide-react'
import { useState } from 'react'

import { de } from '../i18n/de'
import { formatTrackingNumber } from '../lib/format'

export function TrackingNumber({
  value,
  display,
  label = de.parcel.trackingNumber,
}: {
  /** Copied to the clipboard verbatim. */
  value: string
  /**
   * Shown instead of the grouped-digit formatting — for an order-keyed Amazon parcel
   * this is the dashed order number, which already reads fine on its own.
   */
  display?: string
  /** Prefixed to the tooltip so it reads correctly for order-keyed parcels. */
  label?: string
}) {
  const [copied, setCopied] = useState(false)

  async function copy(event: React.MouseEvent) {
    event.stopPropagation()
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 1500)
    } catch {
      /* clipboard blocked (insecure origin) — the number stays selectable by hand */
    }
  }

  return (
    <button
      type="button"
      onClick={copy}
      title={`${label} – ${copied ? de.parcel.copied : de.parcel.copyNumber}`}
      className="tracking-number group inline-flex items-center gap-1 rounded text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-100"
    >
      {display ?? formatTrackingNumber(value)}
      {copied ? (
        <Check className="h-3 w-3 text-emerald-600" aria-hidden />
      ) : (
        <Copy className="h-3 w-3 opacity-0 transition group-hover:opacity-100" aria-hidden />
      )}
    </button>
  )
}
